import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../lib/api';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { toast } from 'sonner';
import { Settings, Link2, Users, ArrowUpRight } from 'lucide-react';
import { Card } from '../../../components/ui/card';
import { PageHeader } from './DemoUI';

export default function DemoSetupPage() {
  const navigate = useNavigate();
  const [webhook, setWebhook] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/training/demos/config/webhook').then((r) => setWebhook(r.data.webhook_url || '')).catch(() => {});
  }, []);

  const saveWebhook = async () => {
    setBusy(true);
    try { await api.put('/training/demos/config/webhook', { webhook_url: webhook }); toast.success('Webhook saved'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Failed to save'); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-5 max-w-4xl" data-testid="demo-setup-page">
      <PageHeader icon={Settings} eyebrow="Trainer Demo" title="Setup" subtitle="Approval notification webhook." testid="demo-setup-header" />

      <Card className="p-5 border space-y-3" data-testid="webhook-section">
        <h2 className="text-[13.5px] font-semibold text-slate-900 flex items-center gap-2">
          <span className="w-8 h-8 rounded-lg bg-violet-100 text-violet-700 flex items-center justify-center"><Link2 className="w-4 h-4" /></span>
          Approval notification webhook
        </h2>
        <p className="text-[12px] text-slate-500">Google Chat / Pabbly incoming webhook URL. A message fires whenever a demo is approved. Leave blank to disable.</p>
        <div className="flex flex-wrap gap-2">
          <Input value={webhook} onChange={(e) => setWebhook(e.target.value)} placeholder="https://chat.googleapis.com/v1/spaces/…" className="h-10 flex-1 min-w-[260px] bg-white font-mono text-[12px]" data-testid="webhook-input" />
          <Button onClick={saveWebhook} disabled={busy} className="h-10 bg-violet-600 hover:bg-violet-700" data-testid="webhook-save">Save</Button>
        </div>
      </Card>

      <Card className="p-5 border flex flex-wrap items-center justify-between gap-3" data-testid="counsellor-logins-pointer">
        <div className="flex items-start gap-3">
          <span className="w-8 h-8 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center shrink-0"><Users className="w-4 h-4" /></span>
          <div>
            <h2 className="text-[13.5px] font-semibold text-slate-900">Counsellor logins</h2>
            <p className="text-[12px] text-slate-500 mt-0.5">Managed in Masters → Counsellors — create, reset, enable or remove a login right on the counsellor row.</p>
          </div>
        </div>
        <Button variant="outline" size="sm" className="h-9 text-[12px]" onClick={() => navigate('/training/masters?tab=counsellors')} data-testid="goto-counsellor-master">
          Open Masters <ArrowUpRight className="w-3.5 h-3.5 ml-1.5" />
        </Button>
      </Card>
    </div>
  );
}
